import React, { useEffect, useState } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import BRModal from '../../assets/dsgov/js/components/modal';
import '../../assets/dsgov/css/components/modal.css';
import './Modal.css';

const Modal = (_props) => {
  const props = parseProps(_props);
  const [componentId] = useState(
    `modal${componentIdGenerator()}`,
  );
  useEffect(() => {
    new BRModal('br-modal', window.document.querySelector(`.${componentId}`));
  });

  const classes = `br-modal ${componentId} ${props.classes || null}`;
  return (

    <div className={classes}>
      <div className="br-modal-dialog">
        <div className="br-modal-content">
          <div className="br-modal-header">
            <h2 className="br-modal-title">{props.title}</h2>
          </div>
          <div className="br-modal-body">
            {props.content}
          </div>
          <div className="br-modal-footer justify-content-end">
            {props.buttons}
          </div>
        </div>
      </div>

    </div>

  );
};

export default Modal;
